const doc = [({"zh_tw":({"adminLabelActivity":({"facilityName":"設施名稱"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;